import { render, staticRenderFns } from "./BetgameEditChatBot.vue?vue&type=template&id=a6748c2c&scoped=true"
import script from "./BetgameEditChatBot.vue?vue&type=script&lang=js"
export * from "./BetgameEditChatBot.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditChatBot.vue?vue&type=style&index=0&id=a6748c2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6748c2c",
  null
  
)

export default component.exports